<template>
	<div>
		<div class=" m-auto">
			<div class="flex flex-wrap content-center justify-center">
				<div class="w-full sm:w-6/12 lg:w-9/12 p-4">
					<ul class="breadcrumb text-sm md:text-base">
						<li class="is-active">
							<p>نتيجة البحث عن : {{searchParameter}}</p>
						</li>
					</ul>
				</div>
				<div class="w-full sm:w-6/12 lg:w-3/12 p-4">
					<div class="filter">
						<form class="">
							<label class="flex text-secondary-300 text-sm font-semibold">
								<span class="flex-shrink-0 self-center rtl:ml-4 ltr:mr-4">{{ t('order_by') }}</span>
								<div class="select block w-full">
									<select class="form-select w-full border-secondary-300 rounded-lg text-sm" v-model="orderBy" name="brand_filter">
										<option selected value="name">{{ t('name') }}</option>
										<option value="created_at">{{ t('last_added')}}</option>
										<option value="views">{{ t('views') }}</option>
										<option value="price_desc">{{ t('high_price')  }}</option>
										<option value="price_asc">{{ t('low_price') }}</option>
									</select>
								</div>
							</label>
						</form>
					</div>
				</div>
				<div class="w-full py-4 px-4 md:px-1">
					<div class="flex flex-wrap content-center justify-start" v-lazy-container="{ selector: 'img' }">
						<product-card v-for="product in products" :key="product.id" sitelocale="ar" :auth="auth" :product="product" :is-fav="'true'"
									  fav-route="#" compare="#" :card="true"  :slider="false" card-width="sm:w-1/2 md:w-4/12 lg:w-3/12" store="#"></product-card>
					</div>
				</div>
			</div>
		</div>		
	</div>
</template>

<script>
	import axios from 'axios';
	import infiniteScroll from 'vue-infinite-scroll';
	export default {
		name: "SearchResults",
		directives: {
			infiniteScroll
		},
		props: {
			url:{
				type: String,
				required: true
			},
			searchParameter:{
				type: String,
				required: false
			},
			storeLink:{
				required: true,
				type: String,
			},
			auth: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				fetching: true,
				sortOrder: 'desc',
				orderBy: 'name',
				filter: 'name',
				products:[],
			};
		},
		mounted() {
			this.$translate.setLang(this.sitelocale);
		},
		created(){
			axios.get(this.url,
			{
				params : {
					'orderBy' : this.filter, 'direction' : this.sortOrder, 'search' : this.searchParameter
				}
			}

			).then(({ data }) => {
				this.products.push(...data.data);
				this.fetching = false;
			});
		},
		methods:{
			getOrderBy(val) {
				if(val == 'price_asc') {
					this.sortOrder = 'asc';
					this.filter = 'price';
				} else if(val == 'price_desc') {
					this.sortOrder = 'desc';
					this.filter = 'price';
				} else {
					this.sortOrder = 'desc';
					this.filter = val;
				}
			},
			
		},
		watch: {
			orderBy: function (val) {
				this.getOrderBy(val);
				this.products = [];
				axios.get(this.url,
				{
					params : {
						'orderBy' : this.filter, 'direction' : this.sortOrder, 'search' : this.searchParameter
					}
				}
				)
				.then(({data}) => {
					this.products.push(...data.data);
					this.fetching = false;
				});
			},
		}

	};
</script>


// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/Search/SearchResults.vue